import { ReactNode } from 'react'

export interface FooterIconLinkProps {
  elem: ReactNode
  href: string
  onClick: () => void
}

export const FooterIconLink = ({
  elem,
  href,
  onClick,
}: FooterIconLinkProps) => (
  <a
    href={href}
    className="cursor-pointer"
    target="_blank"
    rel="noopener noreferrer"
    onClick={onClick}
  >
    {elem}
  </a>
)
